import React from 'react';
import Top from '../components/Top';
import Footer from '../components/Footer';
import styled from 'styled-components';
import ParticleSystem from '../components/particles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Main = styled.div`
  flex: 1;
 background:black;
  
`;
const isMobile = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth < 768;
  }
  return false;
};

const Layout = (WrappedComponent) => {
  const showParticles = !isMobile();
  return (props) => (
    <Container >
   
             <Top />
                {/* {showParticles && <ParticleSystem />} */}
       <WrappedComponent {...props} />
      {/* <Main>
       
        
      </Main> */}
      {/* <Footer /> */}
    </Container>
  );
};

export default Layout;
